import { v1 } from './v1';

export const playerConfig = { v1 };
